<template>
    <div class="page-content">
                  <nav class="page-breadcrumb" id="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">{{breadcrumbA}}</li>
                      <li class="breadcrumb-item active" aria-current="page">{{breadcrumbB}}</li>
                    </ol>
                  </nav>

                  <div class="row">
                    <div class="col-md-12 grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">
                          <h6 class="card-title"><i class="link-icon" data-feather="box"></i> {{breadcrumbB}}</h6>
                          <p class="card-description">
                           {{descripcion}}
                            </p>
                        </div>  
                      </div>
                    </div>
                  </div>    

                 <lista-carga v-if="triggers.load"></lista-carga>

                  <div class="row" v-else>
                    <div class="col-md-12 grid-margin stretch-card">
                      <div class="card">
                        <div class="card-body">


                               <div class="row mb-3">
                                <div class="col">
                                    <label class="mr-sm-2">Numero de liquidación</label>
                                    <select id="liqui" v-model="liquidacionSeleccionada" class="form-control">
                                        <option disabled value="">Seleccioná una liquidación</option>
                                        <option
                                            v-for="liq in liquidaciones"
                                            :key="liq.liquidacion"
                                            :value="String(liq.liquidacion)"
                                        >
                                            {{ liq.option }}
                                        </option>
                                    </select>
                                </div>
                                
                                <div class="col">
                                    <label class="mr-sm-2 w-100" for="">&nbsp;</label>
                                    <button  class="btn btn-md btn-success w-100" @click="obtenerPersonal()">Consultar</button>
                                </div>
                            </div>


                          <div class="table-responsive">
                            <table id="empresas" class="table">
                              <thead>
                                <tr>
                                  
                                  <th>Id</th>
                                  <th>Nombre y Apellido</th>
                                  <th>Categoria</th>
                                  <th>CBU</th>
                                  <th>Importe Neto</th>
                                  <th>AÑO</th>
                                  <th>MES</th>
                                  <th>DIA</th>
                                  <th>CUIL</th>
                                  <th>CONCEPTO</th>
                                  <th>FIRMADO</th>
                                  <th>RECIBO</th>
                                  <th>DESCARGAR</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="personal in personal" v-bind:key="personal">
                                  
                                    <td>{{personal.legajo}}</td>
                                    <td>{{personal.nombre}}</td>
                                    <td>{{personal.categoria}}</td>
                                    <td>{{personal.cbu}}</td>
                                    <td>{{personal.neto}}</td>
                                    <td>{{personal.anio}}</td>
                                    <td>{{personal.mes}}</td>
                                    <td>{{personal.dia}}</td>
                                    <td>{{personal.cuil}}</td>
                                    <td>LIQUIDACIÓN{{personal.mes}}{{personal.anio}}</td>
                                     <td>{{personal.firmado}}</td>
                                    <td><a target="_blank" :href="personal.recibo">VER</a></td>
                                    <td v-if="personal.firmado=='Conforme'"><a href="#" @click.prevent="descargarReciboFirmado(personal)">DESCARGAR</a></td>
                                    <td v-else>-</td>
                                   
                                </tr>
                              </tbody>
                            </table>
                              <div class="alert alert-danger"  role="alert" id="alerta">
                                  Escribe un número de liquidación y consulta.
                                </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                <modal-administrar
                    v-if="modalAdministrar.open" 
                    :empresa="modalOperacionId"
                    :legajoEmpleado="modalAdministrar.legajo"
                    :nombreEmpleado="modalAdministrar.nombre"
                    :apellidoEmpleado="modalAdministrar.apellido"
                    :operacion="modalAdministrar.operacion"
                    :idDistribucion="modalAdministrar.idDistribucion"
                    @cerrar-modal-asignar="refrescarPersonal($event)"
                >
                </modal-administrar>

                <modal-legales
                    v-if="modalLegales.open" 
                    :dniEmpleado="modalLegales.dni"
                    :nombreEmpleado="modalLegales.nombre"
                    :apellidoEmpleado="modalLegales.apellido"
                    :legajoEmpleado="modalLegales.legajo"
                    @cerrar-modal-legales="refrescarPersonal($event)"
                ></modal-legales>

            </div>
     

</template>

<script>

import axios from 'axios';
import $ from 'jquery';
require('datatables.net');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.flash.js')();
require('datatables.net-buttons/js/buttons.print.js')();
import ListaCarga from '../ListaCarga.vue';
import ModalAdministrar from './ModalAdministrar.vue';
import ModalLegales from './ModalLegales';
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));
//$("title").html("Liquidacion");
export default {
    name: 'Liquidacion',
    components: {ListaCarga, ModalAdministrar, ModalLegales},
    data() {
        return {
            breadcrumbA: 'Inicio',
            breadcrumbB: 'Liquidacion Food Service America',
            descripcion: 'En este modulo usted podra generar archivo csv valido para enviar al BANCO',
            triggers: {load:true},
            personal: [],
            liquidaciones: [],
            liquidacionSeleccionada: '',
            modalAdministrar: {
                open: false,
                legajo: null,
                nombre: null,
                apellido: null,
                operacion: null,
                idDistribucion: null,
            },
            modalLegales: {
                open: false,
                dni: null,
                nombre: null,
                apellido: null,
            },
        }
    },
    methods: {
        isEditor(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            // console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
        },
        abrirModalAdministrar(legajo,nombre,apellido,operacion,idDistibucion){
            this.modalAdministrar.legajo = legajo;
            this.modalAdministrar.nombre = nombre;
            this.modalAdministrar.apellido = apellido;
            this.modalAdministrar.operacion = (operacion == '-') ? undefined : operacion;
            this.modalAdministrar.idDistribucion = idDistibucion;
            this.modalAdministrar.open = true;
        },
        abrirModalLegales(dni,nombre,apellido,legajo){
            this.modalLegales.dni = dni;
            this.modalLegales.nombre = nombre;
            this.modalLegales.apellido = apellido;
            this.modalLegales.legajo = legajo;
            this.modalLegales.open = true;
        },
        obtenerMesCalendario(option, mesFirebase){
            const texto = String(option || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase();

            const meses = {
                enero: 1,
                febrero: 2,
                marzo: 3,
                abril: 4,
                mayo: 5,
                junio: 6,
                julio: 7,
                agosto: 8,
                septiembre: 9,
                setiembre: 9,
                octubre: 10,
                noviembre: 11,
                diciembre: 12,
            };

            for (const nombreMes in meses) {
                if (texto.indexOf(nombreMes) !== -1) {
                    return meses[nombreMes];
                }
            }

            // Casos especiales que no incluyen el nombre del mes en option.
            if (/s\.?a\.?c\.?[^0-9]*1[^0-9]*semestre/.test(texto)) {
                return 6;
            }
            if (/s\.?a\.?c\.?[^0-9]*2[^0-9]*semestre/.test(texto)) {
                return 12;
            }

            // Ejemplo: "Ajuste CCT 11/2024".
            const mesExplicito = texto.match(/(?:^|\D)(0?[1-9]|1[0-2])\/\d{4}(?:$|\D)/);
            if (mesExplicito) {
                return parseInt(mesExplicito[1], 10);
            }

            // Respaldo para la estructura histórica: Firebase guarda el mes anterior.
            const mesBase = parseInt(mesFirebase, 10);
            if (!isNaN(mesBase)) {
                if (mesBase >= 1 && mesBase <= 11) {
                    return mesBase + 1;
                }
                if (mesBase === 12) {
                    return 1;
                }
            }

            return 1;
        },
        obtenerFechaPago(anio, mesCalendario){
            let anioPago = parseInt(anio, 10);
            let mesPago = parseInt(mesCalendario, 10) + 1;

            if (mesPago > 12) {
                mesPago = 1;
                anioPago += 1;
            }

            return anioPago + '-' + String(mesPago).padStart(2, '0') + '-06';
        },
        construirUrlRecibo(liquidacion, dni, anio, mesCalendario, banco, fecha){
            const parametros = [
                'r=AME',
                'l=' + encodeURIComponent(liquidacion),
                'd=' + encodeURIComponent(dni),
                'mes=' + encodeURIComponent(mesCalendario),
                'anio=' + encodeURIComponent(anio),
                'banco=' + encodeURIComponent(banco),
                'fecha=' + encodeURIComponent(fecha),
            ];

            return 'https://servicio.foodservice.com.ar/mifoodtest/getrcb/recibo.php?' + parametros.join('&');
        },
        construirUrlReciboFirmado(liquidacion, dni, token){
            const liquidation = String(liquidacion || '').trim();
            const documento = String(dni || '').replace(/\D/g, '');
            const firmaToken = String(token || '').trim();

            if (!/^\d+$/.test(liquidation)) {
                throw new Error('La liquidación seleccionada no es válida.');
            }
            if (!documento) {
                throw new Error('No se pudo identificar el DNI del empleado.');
            }
            if (!firmaToken) {
                throw new Error('No se encontró un token de firma válido para el empleado.');
            }

            return 'https://servicio.foodservice.com.ar/core/signa/private.php'
                + '?action=download'
                + '&liqui=' + encodeURIComponent(liquidation)
                + '&doc=' + encodeURIComponent(documento)
                + '&token=' + encodeURIComponent(firmaToken);
        },
        async obtenerTokenFirmaEmpleado(dni){
            const documento = String(dni || '').replace(/\D/g, '');
            if (!documento) {
                throw new Error('No se pudo identificar el DNI del empleado.');
            }

            const respuesta = await axios.get(
                'https://aplicativos.firebaseio.com/token/' + encodeURIComponent(documento) + '.json?print=pretty'
            );

            const data = respuesta.data;
            if (typeof data === 'string' && data.trim() !== '') {
                return data.trim();
            }

            if (data && typeof data === 'object') {
                const tokens = Object.keys(data)
                    .map(clave => data[clave])
                    .filter(valor => typeof valor === 'string' && valor.trim() !== '')
                    .map(valor => valor.trim());

                if (tokens.length) {
                    // Se usa un token ya validado para ese DNI, igual que en recibos.html.
                    return tokens[tokens.length - 1];
                }
            }

            throw new Error('El empleado no tiene un dispositivo/token de firma validado.');
        },
        async descargarReciboFirmado(personal){
            const liquidacion = String(this.liquidacionSeleccionada || '').trim();
            const dni = String((personal && personal.dni) || '').replace(/\D/g, '');

            if (!liquidacion || !dni) {
                $('#alerta').text('No se pudo identificar la liquidación o el DNI para descargar el recibo.').show();
                return;
            }

            // Se abre la pestaña durante el click para evitar bloqueos del navegador
            // mientras se obtiene el token validado del empleado.
            const ventana = window.open('about:blank', '_blank');

            try {
                const token = await this.obtenerTokenFirmaEmpleado(dni);
                const url = this.construirUrlReciboFirmado(liquidacion, dni, token);

                if (ventana) {
                    ventana.opener = null;
                    ventana.location.href = url;
                } else {
                    $('#alerta').text('El navegador bloqueó la descarga. Habilitá las ventanas emergentes e intentá nuevamente.').show();
                }
            } catch (error) {
                if (ventana && !ventana.closed) {
                    ventana.close();
                }
                console.error('No se pudo descargar el recibo firmado:', error);
                $('#alerta').text(
                    error && error.message
                        ? error.message
                        : 'No se pudo descargar el recibo firmado.'
                ).show();
            }
        },
        cargarOpcionesLiquidacion(liquidaciones){
            const registros = Object.keys(liquidaciones || {})
                .map(clave => liquidaciones[clave])
                .filter(value => value && value.liquidacion)
                .map(value => {
                    const mesCalendario = this.obtenerMesCalendario(value.option, value.mes);
                    return {
                        liquidacion: String(value.liquidacion),
                        option: value.option || ('Liquidación ' + value.liquidacion),
                        anio: parseInt(value.anio, 10),
                        mesFirebase: value.mes,
                        mesCalendario: mesCalendario,
                        fechaPago: this.obtenerFechaPago(value.anio, mesCalendario),
                    };
                })
                .sort((a, b) => parseInt(b.liquidacion, 10) - parseInt(a.liquidacion, 10));

            this.liquidaciones = registros;

            // Conserva la selección actual; si no existe, selecciona la más reciente.
            const seleccionExiste = registros.some(item => item.liquidacion === String(this.liquidacionSeleccionada));
            if (!seleccionExiste) {
                this.liquidacionSeleccionada = registros.length ? registros[0].liquidacion : '';
            }
        },
        async obtenerPersonal(){
            const liquidacion = String(this.liquidacionSeleccionada || '');
            const opcionSeleccionada = this.liquidaciones.find(
                item => String(item.liquidacion) === liquidacion
            );

            if (!liquidacion || !opcionSeleccionada) {
                $('#alerta').text('Seleccioná una liquidación antes de consultar.').show();
                return;
            }

            const anio = parseInt(opcionSeleccionada.anio, 10);
            const mes = parseInt(opcionSeleccionada.mesCalendario, 10);
            const fechaPago = opcionSeleccionada.fechaPago || this.obtenerFechaPago(anio, mes);
            const banco = 'BBVA';
            const dia = '06';

            this.triggers.load = true;

            if ($.fn.DataTable.isDataTable('#empresas')) {
                $('#empresas').DataTable().destroy();
            }
            const axiosrequest1 = axios.get('https://auth.foodservice.com.ar/?type=liq_fs_america&liquidacion=' + encodeURIComponent(liquidacion) + '&access_token=1234567');
            
            
            const axiosrequest2 = axios.get('https://aplicativos.firebaseio.com/categorias.json?print=pretty');

            const axiosrequest3 = axios.get('https://aplicativos.firebaseio.com/recibos/AME/' + encodeURIComponent(liquidacion) + '.json');
        
            await axios.all([axiosrequest1, axiosrequest2, axiosrequest3]).then(
            axios.spread((personal, categorias, firmado) => {
                var lista = [];

            const zfill = (number, width) => {
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }


const formatMoney = (number, decPlaces, decSep, thouSep) => {
    decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
    decSep = typeof decSep === "undefined" ? "," : decSep;
    thouSep = typeof thouSep === "undefined" ? "." : thouSep;
    var sign = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;

    return sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSep) +
        (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
};

                const result_categoria = (id) => {
                    var categoria = "";
                    $.each(categorias.data, function(clave, value) {

                        if (value.codigo == id) {
                            categoria = value.nombre;
                        }
                    })
                    return categoria;
                }



                const result_firmado = (id) => {
                    var firma = "-";
                    $.each(firmado.data, function(clave, value) {

                        if (clave == id) {
                            
                            if (value.status==1) {
                                firma = "Conforme";
                            }

                             if (value.status==2) {
                                firma = "No conforme";
                            }

                            
                        }
                    })
                    return firma;
                }

              


                const reemplazarIndefinido = (string) => {
                    if (string==undefined || string == null || string == '') {
                        return "-"
                    }
                    return string
                }


                $.each(personal.data, (clave, valor) => {
                         var recibo = this.construirUrlRecibo(
                             liquidacion,
                             valor.datos.dni,
                             anio,
                             mes,
                             banco,
                             fechaPago
                         );

                        lista.push({
                            
                            "legajo": zfill(reemplazarIndefinido(valor.datos.legajo), 18),
                            "categoria": reemplazarIndefinido(result_categoria(valor.datos.cat_tipo)),
                            "nombre": reemplazarIndefinido(valor.datos.nombre),
                            "dni": String(valor.datos.dni || ''),
                            "recibo": recibo,
                            "cbu": reemplazarIndefinido(valor.datos.CBU),
                            "neto": formatMoney(reemplazarIndefinido(valor.datos.neto)),
                            "anio": anio,
                            "mes": mes,
                            "dia": dia,
                            "cuil": reemplazarIndefinido(valor.datos.Cuil),
                            "firmado":result_firmado(valor.datos.dni)
                        })
                    
                });
                // console.log(lista);
                this.personal = lista;
                })).then(async () => {
                    this.triggers.load = false;
                    await this.$nextTick();
                    $("#alerta").hide();
                    $('#empresas').DataTable({
                        "language": {
                            "decimal": ",",
                            "thousands": ".",
                            "info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                            "infoPostFix": "",
                            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                            "loadingRecords": "Cargando...",
                            "lengthMenu": "Mostrar _MENU_ registros",
                            "paginate": {
                                "first": "Primero",
                                "last": "Último",
                                "next": "Siguiente",
                                "previous": "Anterior"
                            },
                            "processing": "Procesando...",
                            "search": "Buscar:",
                            "searchPlaceholder": "Término de búsqueda",
                            "zeroRecords": "No se encontraron resultados",
                            "emptyTable": "Ningún dato disponible en esta tabla",
                            "aria": {
                                "sortAscending":  ": Activar para ordenar la columna de manera ascendente",
                                "sortDescending": ": Activar para ordenar la columna de manera descendente"
                            },
                        },
                        "scrollX": false, 
                        "search": {regex:true},
                        dom: 'Bfrtip',
                        responsive: false,
                        nowrap: false,
                        buttons: [
                            'copy',
                            'excel',
                            'csv',
                            'pdf',
                   ]
                    });
                }).catch(async (error) => {
                    console.error('No se pudo consultar la liquidación:', error);
                    this.triggers.load = false;
                    await this.$nextTick();
                    $('#alerta').text('No se pudieron traer las personas de la liquidación seleccionada.').show();
                });

        },
        refrescarPersonal(seReasigno){
            this.modalAdministrar.open = false;
            this.modalLegales.open = false;
            if (seReasigno) {
                $('#empresas').dataTable().fnDestroy();
                this.obtenerPersonal();
            }

            // this.$nextTick(()=>{
            // })
        },
    },
   async mounted() {
        this.triggers.load = true;

        try {
            const liquidaciones = await axios.get('https://aplicativos.firebaseio.com/liquidacion_recibos/AME.json');
            this.cargarOpcionesLiquidacion(liquidaciones.data);
        } catch (error) {
            console.error('No se pudieron cargar las liquidaciones:', error);
            $('#alerta').text('No se pudieron cargar las liquidaciones disponibles.').show();
        } finally {
            this.triggers.load = false;
        }

    },
};
</script>

<style scoped>
.fila-no-distribuido {
    /* color: red; */
    /* text-shadow: rgba(255, 0, 0, 0.603) 0px 0px 1px; */
    background: radial-gradient(#ff00001a, transparent 91%);
}
</style>